// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const GridContract = contract({
  name: "Grid",
  description: "2D layouts where Stack (vertical) and Row (horizontal) don't fit — stat-card grids, feature tiles, pricing columns, photo grids. Reach for Grid over hand-rolled `grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4` so the column count is a prop the settings panel can mutate and the responsive ladder stays consistent across designs.",
  import: "@gradeui/ui",
  aliases: ["grid","tiles","cards grid","stat grid","columns","feature grid","grid view","lazy v grid","lazyvgrid","lazy h grid","lazyhgrid","tile grid","masonry"],
  composesWith: ["Card","Stack (inside each cell)","Row","Button","any content component"],
  styleDefaults: {"Grid":"gds-grid grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 items-stretch"},
  variantDefaults: {"cols":"3","gap":"md","align":"stretch"},
  props: {
  "cols": {
      schema: z.enum(["1", "2", "3", "4", "5", "6", "12"]).optional(),
      design: "knob",
      description: "desktop column count; each value has a baked-in responsive ladder (e.g. \"4\" → 1 col mobile, 2 tablet, 4 desktop)",
      default: "3",
  },
  "gap": {
      schema: z.enum(["none", "xs", "sm", "md", "lg", "xl", "2xl"]).optional(),
      design: "knob",
      description: "gap between grid cells (same scale as Stack/Row)",
      default: "md",
  },
  "align": {
      schema: z.enum(["start", "center", "end", "stretch"]).optional(),
      design: "knob",
      description: "cross-axis alignment of cells",
      default: "stretch",
  },
  "asChild": {
      schema: z.boolean().optional(),
      design: "plumbing",
      description: "render as the child element via Slot",
      default: false,
  },
  "className": {
      schema: z.string().optional(),
      design: "plumbing",
  },
  "children": {
      schema: z.unknown(),
      design: "plumbing",
  },
  },
});
